import { render, staticRenderFns } from "./group.vue?vue&type=template&id=6b35625a&scoped=true"
import script from "./group.vue?vue&type=script&lang=ts"
export * from "./group.vue?vue&type=script&lang=ts"
import style0 from "./group.vue?vue&type=style&index=0&id=6b35625a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35625a",
  null
  
)

export default component.exports